var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85354 2.39999H3.38296C3.00853 2.39999 2.64944 2.54749 2.38469 2.81004C2.11993 3.0726 1.97119 3.42869 1.97119 3.79999V12.2C1.97119 12.5713 2.11993 12.9274 2.38469 13.1899C2.64944 13.4525 3.00853 13.6 3.38296 13.6H5.85354M6.029 7.99999H14.029M14.029 7.99999L10.9722 4.79999M14.029 7.99999L10.9722 11.2",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1902af7a785bc00fa402f1817546d7cc.svg";
export { ForwardRef as ReactComponent };